<template>
  <div v-draggable="draggableValue" v-bind="$attrs" v-on="$listeners" class="dialogbox" v-if="visible">
    <slot></slot>
  </div>
</template >

<script>
export default {
	props: {
		visible: {
			type: Boolean,
			default: false,
			desc: '显示弹窗',
		},
	},
	data() {
		return {
			handleId: 'handle-id',
			draggableValue: {
				handle: undefined,
			},
		}
	},
	mounted() {
		this.draggableValue.handle = this.$refs[this.handleId] // 弹窗拖动
	},
}
</script>

<style scoped>
.dialogbox {
	position: fixed;
	top: 50%;
	left: 50%;
	width: 320px;
	padding: 10px;
	background-color: #43434375;
	color: white;
	z-index: 3000;
	font-size: 10px;
}
</style>